module.exports = __webpack_public_path__ + "assets/dash.e1b232c1.svg";